import React from 'react';
import { observable, computed, action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import Avatar from '../Components/Avatar';
import MentionsField from './MentionsField';

import utils from './utils';

class CommentField extends React.Component {
    processing = false;
    comment = '';

    constructor (props) {
        super(props);

        makeObservable(this, {
            processing: observable,
            comment: observable,
            error: computed,
            isEmpty: computed,
            onCommentInput: action,
            setContent: action,
            setProcessing: action,
            clear: action
        });
    }

    get error () {
        return this.comment.length > 5000
            ? gettext('The maximum length is 5000 symbols.')
            : '';
    }

    setContent = content => {
        this.mentionsField.textareaElement.innerHTML = content;
        this.comment = content;
    };

    clear = () => {
        this.mentionsField.textareaElement.innerHTML = '';
        this.comment = '';
    };

    setFocus = () => this.mentionsField.textareaElement.focus();

    hasError = () => this.error;

    isProcessing = () => this.processing;

    get isEmpty () {
        return !utils.validateCommentWithoutHTML(this.comment);
    }

    getContent = () => this.mentionsField.textareaElement.innerHTML;

    getComment = () => this.comment;

    setProcessing = value => {
        this.processing = value;
    };

    onCommentInput = event => {
        this.comment = event.nativeEvent.target.innerHTML;
    };

    stopPropagation = e => e.stopPropagation();

    renderErrorMessage = () =>
        (<div
            className='validation-block'
            onClick={this.stopPropagation}
        >
            {
                this.error &&
                    <span className='di-input-text di-input-error'>
                        { this.error }
                    </span>
            }
        </div>);

    render () {
        return (<div className='comment-field'>
            <div className='comment-one-liner'>
                <Avatar
                    name={Settings.user.fullName}
                    email={Settings.user.email}
                    login={Settings.user.login}
                />
                <MentionsField
                    ref={mentionsField => { this.mentionsField = mentionsField; }}
                    placeholder={this.props.placeholder}
                    onChange={this.onCommentInput}
                    onKeyPress={this.onCommentInput}
                    onEnter={this.props.onEnter}
                    onEscape={this.props.onEscape}
                    onBlur={this.props.onBlur && this.props.onBlur}
                    commentsStore={this.props.commentsStore}
                />
            </div>
            { this.renderErrorMessage() }
            {
                !this.isEmpty &&
                    (this.props.childrenFunc ? this.props.childrenFunc() : this.props.children)
            }
        </div>);
    }
}

export default observer(CommentField);

CommentField.propTypes = {
    childrenFunc: PropTypes.func,
    onEnter: PropTypes.func,
    onEscape: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    commentsStore: PropTypes.object.isRequired
};
